import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { selectEditFurnitureRows, selectFurnitureQuantityError } from 'store/redux-store/placement-mods/selectors';
import { GridCellParams } from '@mui/x-data-grid';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { Controller, useFormContext } from 'react-hook-form';
import { getExistingRow, getNewRow } from './IncludeEdit';

interface GridCellProps {
  [key: string]: any;
}

export const QuantityCell = (cellParams: GridCellParams) => {
  return <Quantity cellParams={cellParams} />;
};

const Quantity = React.memo(function Quantity(cellParams: GridCellProps) {
  const dispatch = useDispatch();
  const [Quantity, setQuantity] = useState(cellParams?.cellParams?.row?.quantity);
  const furnitureEditRequests = useSelector(selectEditFurnitureRows);
  const { control } = useFormContext();
  const RowId = cellParams?.cellParams?.id;
  const furnitureQuantityErrors = useSelector(selectFurnitureQuantityError);
  const checkAndSetEntryValue = value => {
    const pattern = /^[1-9]$/;

    if (pattern.test(value)) {
      setQuantity(value);
      return value;
    } else {
      setQuantity(value.slice(0, -1));
      return null;
    }
  };
  const setQuantityEdit = data => {
    let newRow = furnitureEditRequests.slice(0);
    let EditRow = cellParams?.cellParams?.row?.placementFurnitureId
      ? getExistingRow(furnitureEditRequests, cellParams, false)
      : getNewRow(furnitureEditRequests, RowId);
    let dataToUpdate = checkAndSetEntryValue(data) === null ? null : Number(checkAndSetEntryValue(data));

    let updatedRow = { ...EditRow, quantity: dataToUpdate };
    let editDescriptionIndex = furnitureEditRequests?.findIndex(
      cellParams?.cellParams?.row?.placementFurnitureId
        ? row => row.placementFurnitureId === updatedRow.placementFurnitureId
        : row => row.id === RowId,
    );
    newRow[editDescriptionIndex] = updatedRow;
    dispatch(placementModsAction.setEditFurnitureRows(newRow));
  };

  useEffect(() => {
    if (cellParams?.cellParams?.error !== null && cellParams?.cellParams?.error !== undefined) {
      const val = furnitureQuantityErrors?.filter(el => el.id === cellParams?.cellParams?.id);

      if (val?.length === 0) {
        const arr = furnitureQuantityErrors?.length > 0 ? furnitureQuantityErrors?.slice(0) : [];
        const valueObj = { quantity: cellParams?.cellParams?.error, id: cellParams?.cellParams?.id };
        arr.push(valueObj);
        dispatch(placementModsAction.setFurnitureQuantityError(arr));
      } else {
        const arr = furnitureQuantityErrors?.slice(0);
        let currentObj = arr.find(val => val.id === cellParams?.cellParams?.id);
        let updatedObj = { ...currentObj, quantity: cellParams?.cellParams?.error };
        let editIndex = arr.findIndex(val => val.id === cellParams?.cellParams?.id);
        arr[editIndex] = updatedObj;
        dispatch(placementModsAction.setFurnitureQuantityError(arr));
      }
    }
  }, [cellParams?.cellParams?.error]);

  useEffect(() => {
    if (!cellParams?.cellParams?.row?.include) {
      setQuantity('');
    }
  }, [cellParams?.cellParams?.row?.include]);
  return (
    <>
      <Controller
        name={`'furnitureRequests'${RowId}.quantity`}
        control={control}
        render={({ field: { onChange, onBlur, value, ...rest } }) => (
          <TextField
            variant="outlined"
            size={'small'}
            style={{ width: '150px' }}
            disabled={!cellParams?.cellParams?.row?.include}
            value={cellParams?.cellParams?.row?.include ? Quantity : ''}
            inputProps={{ maxLength: 255 }}
            onBlur={e => {
              setQuantityEdit(e.target.value);
              onBlur();
            }}
            onChange={e => {
              if (e.target.value) {
                checkAndSetEntryValue(e.target.value);
              } else {
                setQuantity(null);
              }
              onChange(e.target.value);
            }}
            {...rest}
          />
        )}
      />
    </>
  );
});
